import { render, staticRenderFns } from "./Form_grxxcj.vue?vue&type=template&id=9b912362&scoped=true"
import script from "./Form_grxxcj.vue?vue&type=script&lang=js"
export * from "./Form_grxxcj.vue?vue&type=script&lang=js"
import style0 from "./Form_grxxcj.vue?vue&type=style&index=0&id=9b912362&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b912362",
  null
  
)

export default component.exports